import React, { createContext, useContext, useMemo } from 'react';

// The sidebar's *filtered* navigation, published so other screens can answer
// "which features does this user actually have" without re-implementing the
// feature-flag / page-permission / role-matrix precedence in Layout. Global
// search is the first consumer: an operator types "cold storage" and gets the
// page, not just records whose code happens to contain those letters.
const NavigationContext = createContext({ items: [], groupLabels: {} });

export function NavigationProvider({ items, groups, children }) {
  const value = useMemo(() => ({
    items: items || [],
    groupLabels: (groups || []).reduce((acc, g) => { acc[g.key] = g.label; return acc; }, {}),
  }), [items, groups]);

  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>;
}

export const useNavigationItems = () => useContext(NavigationContext);

export default NavigationContext;
